import { Validator } from 'vee-validate';

export const ValidationMessages = {

    en: {
        name: 'en',
        messages: {
            _default: (field) => `The ${field} is not valid.`,
            required: () => 'This field is required',
            min: (name, cnt) => `Minimum ${cnt} chars required`,
            min_value: (name, value) => `The field must be ${value} or more.`,

        },
        attributes: {
            email: 'Email'
        }
    },
    hu: {
        name: 'hu',
        messages: {
            _default: (field) => `Hibás ${field}`,
            required: () => 'A mező kitöltése kötelező',
            min: (name, cnt) => `Legalább ${cnt} karakter`,
            min_value: (name, value) => `A mező értéke legalább ${value}.`,
            alpha_spaces: () => 'A mező csak karaktereket és szóközt tartalmazhat'
        },
        attributes: {
            email: 'email',
            zip: 'irányítószám'
        }
    }

};
